import {Module} from 'module/Module'
import {KostReducerNS} from 'module/Kost/reducer/KostReducer'
import {KostEpic} from 'module/Kost/epic/KostEpic'
import {PropID} from 'module/Properties/enum/PropID'
import {KostAuswertungCFDefsEpic} from 'module/Kost/epic/KostAuswertungEpic'

export const KostModule: Module = {
	reducerNS: KostReducerNS,
	epics: [KostEpic, KostAuswertungCFDefsEpic],
	properties: [PropID.evoApps_KostListTemplate],
}